import { useState } from "react";
import { useT } from "@/i18n";
import { AI_TEXT, STANDS, STYLES, PALETTES } from "@/components/ailab/content";
import Studio, { studioField } from "@/components/ailab/Studio";

const pill = (on) => `rounded-full px-4 py-2 font-bold text-sm shadow-sm border-4 ${on ? "border-blue-600 bg-sky-100" : "border-white bg-white"} text-blue-950`;

export const EditActivity = () => {
  const [prompt, setPrompt] = useState("");
  return <Studio prompt={prompt} setPrompt={setPrompt} allowUpload testId="edit-studio" />;
};

export const CharacterActivity = () => {
  const { lang } = useT();
  const tx = AI_TEXT[lang];
  const [c, setC] = useState({ name: "", looks: "", power: "", story: "" });
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value.slice(0, 120) });
  const prompt = c.looks ? `${lang === "es" ? "Un personaje o criatura llamado" : "A character or creature named"} ${c.name || "?"}: ${c.looks}. ${c.power} ${c.story}. ${lang === "es" ? "Estilo 3D brillante para niños, cuerpo completo" : "Shiny 3D kids style, full body"}` : "";
  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-3">
        <input value={c.name} onChange={set("name")} placeholder={tx.charName} className={studioField} data-testid="char-name" />
        <input value={c.power} onChange={set("power")} placeholder={tx.charPower} className={studioField} data-testid="char-power" />
        <input value={c.looks} onChange={set("looks")} placeholder={tx.charLooks} className={studioField} data-testid="char-looks" />
        <input value={c.story} onChange={set("story")} placeholder={tx.charStory} className={studioField} data-testid="char-story" />
      </div>
      {c.name && <p className="bg-pink-100 rounded-2xl px-4 py-2 font-fredoka text-xl font-bold text-blue-950" data-testid="char-card">{c.name}{c.story && <span className="block text-sm font-nunito font-semibold">{c.story}</span>}</p>}
      <Studio prompt={prompt} setPrompt={() => {}} hidePrompt testId="char-studio" />
    </div>
  );
};

export const AdMission = () => {
  const { lang } = useT();
  const tx = AI_TEXT[lang];
  const [s, setS] = useState({ stand: "lemonade", style: "cartoon", palette: "sunny", slogan: "" });
  const pick = (k, v) => setS({ ...s, [k]: v });
  const get = (list, id) => list.find((x) => x.id === id)[lang];
  const prompt = `${lang === "es" ? "Un afiche publicitario alegre para un puesto infantil de" : "A cheerful advertising poster for a kids'"} ${get(STANDS, s.stand)}${lang === "es" ? "" : " stand"}, ${get(STYLES, s.style)}, ${lang === "es" ? "colores" : "colors"} ${get(PALETTES, s.palette)}${s.slogan ? `, ${lang === "es" ? "con el texto grande" : "with big text"}: "${s.slogan}"` : ""}`;
  const Row = ({ title, list, k }) => (
    <div>
      <p className="font-bold text-blue-950 mb-2">{title}</p>
      <div className="flex flex-wrap gap-2">
        {list.map((x) => <button key={x.id} type="button" onClick={() => pick(k, x.id)} className={pill(s[k] === x.id)} data-testid={`ad-${k}-${x.id}`}>{x.dot && <span className={`inline-block w-3 h-3 rounded-full mr-1 ${x.dot}`} />}{x[lang]}</button>)}
      </div>
    </div>
  );
  return (
    <div className="space-y-4">
      <Row title={tx.stand} list={STANDS} k="stand" />
      <Row title={tx.style} list={STYLES} k="style" />
      <Row title={tx.palette} list={PALETTES} k="palette" />
      <input value={s.slogan} onChange={(e) => pick("slogan", e.target.value.slice(0, 60))} placeholder={tx.slogan} className={studioField} data-testid="ad-slogan" />
      <p className="text-sm font-semibold text-blue-900 bg-sky-50 rounded-2xl px-4 py-2" data-testid="ad-prompt-preview">"{prompt}"</p>
      <Studio prompt={prompt} setPrompt={() => {}} hidePrompt testId="ad-studio" />
    </div>
  );
};
